@import 'styles/mixins';

.bodyClassName {
  width: 1054px !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 29.37%, rgba(255, 255, 255, 0.16) 65.76%);

  @include for-phone-only {
    width: inherit !important;
    background: transparent;
    backdrop-filter: none !important;
  }
}

.mobileHeader {
  padding: 5px;
}

.socialGroupContainer {
  padding: 0 30px;
  width: 100%;
  box-sizing: border-box;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.modalContent {
  padding: 10px;
}

.content {
  backdrop-filter: blur(25px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 29.37%, rgba(255, 255, 255, 0.16) 65.76%);
  border-radius: 20px;
  box-shadow: 1px 1px 0 0 #fff inset, 0 8px 37px 0 rgba(0, 0, 0, 0.1);
  padding: 90px 20px;

  @include for-phone-only {
    background: transparent;
    backdrop-filter: none !important;
    box-shadow: none;
    padding: 0;
  }
}

.content,
.ctaContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}

.ctaContainer {
  width: 700px;

  @include for-phone-only {
    width: 100%;
  }
}

.ctaText,
.ctaButtonContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.buttonAndText {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.button {
  border-radius: 99px;
  background: linear-gradient(270deg, var(--magenta-50) 0%, var(--Blue-70, #0179cf) 100%),
    linear-gradient(90deg, #6800ec 0%, #ea00db 100%);
  color: var(--light-100);
  display: flex;
  gap: 2px;
  padding: 12px 15px;

  &:hover {
    cursor: pointer;
  }
}

.ctaText {
  h1 {
    color: var(--dark-80);
    text-align: center;
    font-family: Sohne;
    font-size: 48px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%; /* 52.8px */

    @include for-phone-only {
      font-size: 30px;
      color: var(--light-100);
    }
  }

  h4 {
    color: var(--dark-80);
    text-align: center;
    font-family: Sohne;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 25.2px */
    letter-spacing: 0.36px;
  }
}

.imageVideoAndDescriptionContainer {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 700px;

  @include for-phone-only {
    width: 100%;
  }
}

.autopilotHomeImg {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  height: auto;
  width: 800px;
}

.descriptions {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.description {
  align-items: flex-start;
  background: var(--light-40);
  border-radius: 25px;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 5px;
  padding: 15px 20px 20px 20px;
}

.videoContainer {
  border-radius: 20px;
  cursor: pointer;
  height: auto;
  overflow: hidden;
  position: relative;
  width: 800px;

  &:hover {
    opacity: 0.9;
  }

  @include for-phone-only {
    width: 100%;
    border-radius: 11px;
  }
}

.videoThumbnail {
  width: 100%;
}

.videoPlayContainer {
  background: var(--dark-80);
  border-radius: 50px;
  left: 50%;
  padding: 17px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  @include for-phone-only {
    h4 {
      color: var(--light-100);
    }
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.videoDurationContainer {
  background: var(--dark-80);
  border-radius: 12px;
  bottom: 33px;
  padding: 5px 8px;
  position: absolute;
  right: 34px;

  span {
    color: var(--Light-100, #fff);
    font-family: Sohne;
    font-size: 26.533px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 37.146px */
    letter-spacing: 0.531px;
  }
}

.videoDurationText {
  font-size: 26px;
}
